// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { Group } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';
import { Store } from '@ngrx/store';
import { addToGroupRequested } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.actions';

@Component({
  selector: 'coa-add-to-group-body-list',
  templateUrl: './add-to-group-body-list.component.html',
  styleUrls: ['./add-to-group-body-list.component.scss'],
})
export class AddToGroupBodyListComponent {
  @Input() elements: Group[];
  @Input() clientId: number;
  @Input() selections: number[];

  constructor(
    private store$: Store,
  ) {
  }

  addToGroup(element: Group): void {
    this.store$.dispatch(addToGroupRequested({
      clientId: this.clientId,
      groupId: element.id,
      selections: this.selections,
      version: element.version,
      name: element.name,
    }));
  }
}
